import { Injectable } from '@angular/core';
import { FeedbackConfig } from './feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  config: FeedbackConfig;

  setInititalConfig(config: FeedbackConfig) {
    this.config = Object.assign({}, config);
  }

  getInitialConfig() {
    return this.config;
  }

  createIconList() {
    const iconListLength = 5;

    return Array.apply(null, Array(iconListLength)).map(function () {
      return {
        text: 'star',
        class: 'icon',
      };
    });
  }

  getDate() {
    const yearMonthDateLength = 10;

    // converting new Date() created entire timestamp with hours, minutes and seconds into YYYY-MM-DD format
    return new Date().toJSON().slice(0, yearMonthDateLength).replace(/-/g, '-');
  }

  updateSuccessHeader(config: FeedbackConfig) {
    return (config = {
      ...config,
      modalConfig: {
        ...config.modalConfig,
        header: this.createHeaderConfig(config, false),
      },
      feedbackBodyText: config.successConfig.description,
    });
  }

  updateErrorHeader(error, config: FeedbackConfig) {
    const userError =
      error?.error?.errors?.length &&
      error?.error?.errors[0]?.user_error?.comments?.length &&
      error?.error?.errors[0]?.user_error?.comments[0];

    return (config = {
      ...config,
      modalConfig: {
        ...config.modalConfig,
        header: this.createHeaderConfig(config, true),
      },
      feedbackBodyText: userError ? userError : config.errorConfig.description,
    });
  }

  createHeaderConfig(config, hasError: boolean) {
    return {
      title: hasError ? config.errorConfig.title : config.successConfig.title,
      icon: !hasError ? 'check_circle_active' : '',
      showClose: true,
    };
  }
}
